import React from 'react';

export const component = props => (
  <svg
    style={{ width: '100%' }}
    aria-label={props.label}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 89.5 89.8"
  >
    <path
      fill={props.color}
      d="M73.2 0v44.6l.4-.3 5.7-5.7a3.2 3.2 0 0 1 4.8 0l4.3 4.3a3.2 3.2 0 0 1 0 4.8L73.5 62.6a1 1 0 0 0-.3.7v26.5H0V.2A1.6 1.6 0 0 1 0 0zM2.1 88.2h69.2V64.9h-.1a3.2 3.2 0 0 1-.3.3L59.7 76.4a2 2 0 0 1-.8.5l-8.1 1.7-3 .6v-.3l2.3-10.7a2 2 0 0 1 .5-1Q60.8 57.2 71 47a.8.8 0 0 0 .3-.7V1.9H2zm53-17.5L79.8 46l-2.5-2.4-24.5 24.7zm3.6 3.6l24.7-24.7-2.2-2.1-24.6 24.7zM85 48l2.2-2.2a1 1 0 0 0 .2-.8 1.7 1.7 0 0 0-.4-.8l-4-4c-1-1-1.7-1-2.7 0l-1.5 1.6zM56.5 75.3l-4.8-4.8-1.3 6z"
    />
    <path
      fill={props.color}
      d="M28.6 31.5V34H25c-.2 0-.3 0-.4.2a1 1 0 0 1-.1.3c-.6 1-.5 1.4.4 2.2a2.9 2.9 0 0 1 .8 3.2l-.2.4c-.3 1-.2 1.2.5 1.8a3 3 0 0 1 .8 3.6l-.8 1.8a1 1 0 0 1-.9.6l-4.1.9c-1 .2-1.5 0-1.7-1.1l-2.9-13.6a.6.6 0 0 0-.5-.6 8.4 8.4 0 0 1-6.8-9 8 8 0 0 1 7.9-7.3H28.6v2.3c1 0 2 0 2.9-.2a34.8 34.8 0 0 0 13.1-4.6l3-1.8a.5.5 0 0 0 .3-.5V9a1.1 1.1 0 0 1 1.4-1.1 1 1 0 0 1 .8 1.1v9.4c3.7.8 5.2 4.2 5.3 7a8.1 8.1 0 0 1-1.8 5.6 6 6 0 0 1-3.4 2.1v9.2a1.1 1.1 0 1 1-2.3 0v-3.5a.7.7 0 0 0-.3-.7 49 49 0 0 0-10.3-5 29.6 29.6 0 0 0-8-1.5h-.7zm19.5-16.3c-6 3.7-12.3 6.3-19.3 6.4v7.6c7 .2 13.3 2.8 19.3 6.5zM26.6 31.5V19.2h-9.5a6.1 6.1 0 0 0 .5 12.3h9zm-4 2.3h-4l2.7 12.8 2.3-.5a1.5 1.5 0 0 0 1.3-1.1c.3-1 .3-1.2-.4-1.9a3 3 0 0 1-.9-3.6c.4-1 .3-1.3-.5-2a2.5 2.5 0 0 1-1-2.2 10.4 10.4 0 0 1 .4-1.5zm27.6-3.3c1.7-.4 3.1-2.6 3.1-5s-1.4-4.8-3.1-5.2zM43.1 77.4v2H8v-2zM39.6 68.7v2H8v-2zM36.7 60.1v2H8v-2z"
    />
    <path
      fill={props.color}
      d="M55.3 12.8l1.7 1-2.4 4.2-1.8-1zM61.7 19.3l-4.1 2.4-1-1.8 4.2-2.4zM54.5 32.8L57 37l-1.8 1-2.4-4.2zM61.8 31.5l-1 1.8-4.2-2.4 1-1.8zM58.2 24.5H63v2h-4.8z"
    />
  </svg>
);

export default component;



// WEBPACK FOOTER //
// ./src/components/UI/Img/ServiceSVG/marketingSVG.jsx